import track1 from '../../assets/allagain2022.wav'

export const songPlaylist = [
  {
    img: "",
    songTitle: "ALL AGAIN",
    url: track1,
  },
  {
    img: "",
    songTitle: "BREAKING",
    url: "../../assets/breaking.wav",
  }

]
  

